class BeschikbaarheidRelationApi {
    constructor(DoclrHttp, praktijkContext) {
        'ngInject';

        this.praktijkContext = praktijkContext;
        this.DoclrHttp = DoclrHttp;
    }

    create(newbeschikbaarheidRelation) {
        return this.DoclrHttp.post(this.getListUrl(newbeschikbaarheidRelation.beschikbaarheidId), newbeschikbaarheidRelation);
    }

    update(beschikbaarheidRelation) {
        return this.DoclrHttp.put(this.getUniqueUrl(beschikbaarheidRelation.id, beschikbaarheidRelation.beschikbaarheidId), beschikbaarheidRelation);
    }

    findAll(beschikbaarheidId) {
        return this.DoclrHttp.get(this.getListUrl(beschikbaarheidId));
    }

    checkNonMutliDisciplineParent(groupId) {
        return this.DoclrHttp.get("/api/calendar/v1/party/" + this.praktijkContext.id + "/appointment-type/check-non-multi-discipline-parent/" + groupId);
    }

    checkMutliDisciplineChild(groupId) {
        return this.DoclrHttp.get("/api/calendar/v1/party/" + this.praktijkContext.id + "/appointment-type/check-multi-discipline-child/" + groupId);
    }

    changeSorting(beschikbaarheidId, changeSortingRequest) {
        return this.DoclrHttp.put(this.getListUrl(beschikbaarheidId) + "/change-sorting", changeSortingRequest);
    }

    remove(id, beschikbaarheidId) {
        return this.DoclrHttp.delete(this.getUniqueUrl(id, beschikbaarheidId));
    }

    findAllAvailableAppointmentTypes(beschikbaarheidId) {
        return this.DoclrHttp.get(`${this.getListUrl(beschikbaarheidId)}/available-appointment-types`)
            .then((appointmentTypes) => {
                return appointmentTypes.sort(doclrVertaal.typeSorter)
            });
    }

    getListUrl(beschikbaarheidId) {
        return `/apiv0/party/${this.praktijkContext.id}/beschikbaarheid/${beschikbaarheidId}/beschikbaarheidrelation`;
    }

    getUniqueUrl(id, beschikbaarheidId) {
        return `${this.getListUrl(beschikbaarheidId)}/${id}`;
    }

}

(function () {
    'use strict';

    angular.module('doclr.beschikbaarheidrelation')
        .service('BeschikbaarheidRelationApi', BeschikbaarheidRelationApi)
})();